const nps = {
  nps: {
    npsBreakdown: 'Szczegóły NPS',
    npsScore: 'Wynik NPS',
    npsSpread: 'Rozkład NPS',
    npsDashboard: 'PULPIT NPS',
    npsDetails: 'Szczegóły NPS',
    npsTrend: 'Trend NPS',
    verbatims: 'Pełne raporty',
    timePeriod: 'Okres',
    to: 'do',
    pastMonths: 'Ostatnie %{month} mies.',
    ratingType: 'Typ ocen',
    systemId: 'Identyfikator systemu',
    systemName: 'Nazwa systemu',
    rating: 'Ocena',
    comments: 'Uwagi',
    all: 'Wszystkie',
    promoter: 'Polecający',
    promoters: 'Polecający',
    detractor: 'Krytyk',
    detractors: 'Krytycy',
    passive: 'Obojętni',
    noData: 'Brak dostępnych danych',
    npsDashboardTooltip: {
      whatIs: 'Czym jest Poziom zadowolenia klientów (NPS)?',
      npsDefine:
        'Poziom zadowolenia klientów (Net Promoter Score, NPS) to indeks wartości od −100 do 100, który mierzy chęć klientów do polecania firmy. Jest używany jako wskaźnik zastępczy do pomiaru ogólnego zadowolenia klienta.',
      questionIs:
        'ytanie jest sformułowane następująco: „Z jakim prawdopodobieństwem w skali od 0 do 10 polecisz naszą firmę przyjacielowi lub współpracownikowi?”. Na podstawie liczby wybranej przez klienta są oni klasyfikowani w jednej z następujących kategorii',
      determined:
        'Poziom zadowolenia klientów (NPS) jest określany przez odjęcie odsetka klientów, którzy są krytyczni, od odsetka klientów, którzy są gotowi polecić firmę. Generowany jest wynik od -100 do 100 oznaczający poziom zadowolenia klientów (NPS).',
      how: 'W jaki sposób firma Enphase określa Twój wskaźnik NPS?',
      shownBelow:
        'Enphase prosi właścicieli domów o podanie ocen w aplikacji Enlighten Mobile, jak pokazano na poniższych ilustracjach. Na podstawie dostarczonych ocen wskaźnik NPS określa się w sposób opisany powyżej.'
    },
    timePeriodTooltip:
      'Domyślny okres to ostatnie 13 miesięcy. Jeśli wskaźnik NPS nie jest dostępny dla ostatnich 13 miesięcy, uwzględnia się dane od pierwszego dostępnego miesiąca.',
    verbatimsTooltip:
      'Wszystkie przedstawione tutaj komentarze pochodzą od właścicieli systemów, którzy wyrazili zgodę na udostępnienie ich instalatorom.',
    jan: 'Sty',
    feb: 'Lut',
    mar: 'Mar',
    apr: 'Kwi',
    may: 'Maj',
    jun: 'Cze',
    jul: 'Lip',
    aug: 'Sie',
    sep: 'Wrz',
    oct: 'Paź',
    nov: 'Lis',
    dec: 'Gru',
    ofTotal: 'z łącz.',
    ratings: 'ocen',
    numberOfReviews: 'opinii',
    date: 'Data',
    between0And10: 'Wprowadź wartość z przedziału od 0 do 10',
    lessThan50: 'Liczba znaków powinna być mniejsza od 50',
    npsBasedOnScore: 'NPS równy %{score} na podstawie %{count} ocen'
  }
};
export default nps;
